import useTabStore from "../../../stores/useActiveTab.jsx";
import HomeContent from "./NavContent/HomeContent.jsx";
import AboutContent from "./NavContent/AboutContent.jsx";
import ProjectsContent from "./NavContent/ProjectsContent.jsx";
import SkillsContent from "./NavContent/SkillsContent.jsx";
import ContactContent from "./NavContent/ContactContent.jsx";

const contentMap = {
    Home: HomeContent,
    About: AboutContent,
    Projects: ProjectsContent,
    Skills: SkillsContent,
    Contact: ContactContent,
};

export default function BottomContent() {
    const activeTab = useTabStore((state) => state.activeTab)

    const ContentComp = contentMap[activeTab] || null
    return (
        <div className="transition ease-in duration-5000 p-6 rounded-sm text-center max-w-[100vw]" >
            {ContentComp ? <ContentComp /> : null}
        </div >
    );
}
